export class QueryStringDocumentSearchCriteria {
	public ApprovalStateList: string[];
	public PaymentStateList: string[];

	constructor(other: QueryStringDocumentSearchCriteria) {
		if (!!other) {
			this.ApprovalStateList = other.ApprovalStateList;
			this.PaymentStateList = other.PaymentStateList;
		}
	}
}
